import { render, staticRenderFns } from "./TopGroupsChart.vue?vue&type=template&id=3a95dc7c&scoped=true&"
import script from "./TopGroupsChart.vue?vue&type=script&lang=js&"
export * from "./TopGroupsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a95dc7c",
  null
  
)

export default component.exports